'use client';

import { SplashScreen } from "components/loading-screen";


// ----------------------------------------------------------------------

export default function Loading() {
  return <SplashScreen />;
}
